import resumeEval from "../../assets/resume-eval.png"
export const portfolioData = [
  {
    id: 1,
    image:resumeEval,
    title: "Resume Evaluator - Internal Product",
    category: "web",
  },
  {
    id: 2,
    image:
      "https://cdn.dribbble.com/userupload/5974409/file/original-c0b498540cdc8103d8b1ab7c12688dac.png?resize=1504x1128",
    title: "Admin Dashboard",
    category: "app",
  },
  {
    id: 3,
    image:
      "https://cdn.dribbble.com/userupload/11945087/file/original-41d326b87d54e83efe1168abdcd13aeb.png?resize=1504x1128",
    title: "E-Commerce Application",
    category: "app",
  },
  {
    id: 4,
    image:
      "https://cdn.dribbble.com/users/2117939/screenshots/16753965/media/f696b497e1536ece8fdf054bdba0bba3.png?resize=1200x900&vertical=center",
    title: "Authentication system",
    category: "web",
  }
];

export const portfolioNav = [
  {
    name: "all",
  },
  {
    name: "web",
  },
  {
    name: "app",
  }
];
